import React, { useId } from "react";
import { Box } from "@mui/material";
import { useController } from "react-hook-form";
import { CAutocomplete, CTextField } from "../StyledComponent";
import { useTranslation } from "react-i18next";

function getOptionValue(options = [], option_label, field) {
  if ([null, undefined, ""].includes(field?.value)) return undefined
  if (typeof field.value !== "object") return field.value
  return options?.find((o) => {
    const id_flag = parseInt(o.id) === parseInt(field?.value?.id)
    const value_flag = o[option_label] === field?.value[option_label];
    return id_flag || value_flag
  });
}

function ControlledAutoComplete({
  control, name = "", options = [], input_label, option_label = "name",
  onChange = () => { }, ...props
}) {
  const key = useId();
  const { t } = useTranslation()
  const { field, formState: { errors } } = useController({ control, name });
  const value = getOptionValue(options, option_label, field) ?? null;
  const _onChange = (event, data) => {
    field.onChange(data)
    onChange({ ...event, name }, { ...data })
  }

  return (
    <Box key={key} sx={{ width: '100%', marginBlock: '0.2rem', ...props.ContainerStyle }}>
      <CAutocomplete
        sx={{ ...props.sx }}
        options={options}
        noOptionsText={t('common.no_option')}
        autoHighlight
        value={value}
        getOptionLabel={props?.getOptionLabel ?? ((data) => t(data?.[option_label] ?? data))}
        isOptionEqualToValue={props.isOptionEqualToValue ?? (() => (false))}
        renderInput={(params) => (
          <CTextField
            {...params}
            input_margin='0'
            value={params.inputProps.value || ""}
            error={errors?.[name] ? true : false}
            label={input_label}
            helperText={errors[name]?.['id']?.message || errors[name]?.[name]?.message || ""}
          />
        )}
        renderOption={props?.renderOption ?? (
          (props, option) => (
            <li {...props} key={`${key}${option?.id}`}>
              {t(option?.[option_label] ?? option)}
            </li>
          )
        )}
        onChange={_onChange}
        onInputChange={props?.onInputChange}
        disabled={props.disabled}
        freeSolo={props.freeSolo}
      />
    </Box>
  );
}

export default ControlledAutoComplete;
